import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import useClipboard from 'react-hook-clipboard';
import FileCopyIcon from '@material-ui/icons/FileCopy';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		margin: '0 auto',
	},
	demo: {
		// backgroundColor: 'red',
		padding: '20px',
		maxWidth: '720px',
		margin: '0 auto',
	},
	title: {
		// margin: theme.spacing(4, 0, 2),
	},

	linkStyle: {
		margin: '20px 0px 0px 0px',
		background: 'white',
	},

	firstLetter: {
		textTransform: 'uppercase',
	},

	urlStyle: {
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},

	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
	},
	expandOpen: {
		transform: 'rotate(180deg)',
	},

	desStyle: {
		background: 'white',
	},

	titles: {
		width: '220px',
		display: 'inline-flex',
		marginRight: '40px',
	},

	avatarStyle: {
		paddingTop: '8px',
	},

	linkAway: {
		'& svg': {
			color: '#757575',
		},
	},
}));

function Alert(props) {
	return <MuiAlert elevation={6} variant='filled' {...props} />;
}

const Index = ({ links, onEditLink, removeLink, editState }) => {
	const classes = useStyles();
	const [clipboard, copyToClipboard] = useClipboard();

	const [social, setSocial] = useState('');
	const [socialBoolean, setSocialBoolean] = useState(false);

	const firstletter = (linkTitle) => {
		var str = linkTitle;
		var res = str.charAt(0);
		return res;
	};

	const urlString = (url) => {
		var str = url;
		var strLengt = url.length;
		var res = str.substring(0, 30);
		var urlStr = '';
		if (strLengt > 30) {
			urlStr = `${res}...`;
			return urlStr;
		}
		urlStr = res;
		return urlStr;
	};

	const sendSocial = () => {
		setSocialBoolean(true);
		setSocial('');
		setTimeout(() => {
			setSocialBoolean(false);
		}, 2000);
	};

	const showSocialAlert = (
		<Snackbar
			id={clipboard}
			open={socialBoolean}
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
		>
			<Alert
				action={
					<IconButton
						id={social}
						aria-label='close'
						color='inherit'
						size='small'
						onClick={() => {
							setSocialBoolean(false);
						}}
					>
						<CloseIcon fontSize='inherit' />
					</IconButton>
				}
			>
				Link is copied
			</Alert>
		</Snackbar>
	);

	return (
		<div className={classes.root}>
			{socialBoolean === true ? showSocialAlert : ''}
			<Grid container spacing={2}>
				<Grid item lg={12} md={12} sm={12} xs={12}>
					<div className={classes.demo}>
						<List>
							{links?.map((link) => {
								return (
									<div key={link.id}>
										<ListItem className={classes.linkStyle}>
											<div className={classes.titles}>
												<ListItemAvatar className={classes.avatarStyle}>
													<Avatar>
														<span className={classes.firstLetter}>
															{firstletter(link.title)}
														</span>
													</Avatar>
												</ListItemAvatar>
												<ListItemText
													primary={link.title}
													secondary={link.subTitle}
												/>
											</div>
											<ListItemText
												primary={urlString(link.url)}
												className={classes.urlStyle}
											/>

											<ListItemSecondaryAction>
												<IconButton
													onClick={() => copyToClipboard(link.url, sendSocial)}
												>
													<FileCopyIcon />
												</IconButton>
												<IconButton edge='end' onClick={() => onEditLink(link)}>
													<EditIcon />
												</IconButton>
												<IconButton
													edge='end'
													disabled={editState === false ? false : true}
													onClick={() => removeLink(link.id)}
												>
													<DeleteForeverIcon />
												</IconButton>
												<IconButton
													href={link.url}
													rel='noreferrer'
													color='inherit'
													target='_blank'
													className={classes.linkAway}
												>
													<ExitToAppIcon />
												</IconButton>
											</ListItemSecondaryAction>
										</ListItem>
									</div>
								);
							})}
						</List>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default Index;
